import React, { Component } from "react";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import Select from "react-select";
import HttpService from "../../../services/HttpService";
import {MdArrowDropDown} from "react-icons/md"

export default class UserFilter extends Component {
  state = {
    status: [],
  };
  componentDidMount() {
    this.getLookUp();
  }
  async getLookUp() {
    this.setState({ status: await HttpService.getStatusesList() });
  }
  onEnterPress = (event) => {
    if (event.keyCode === 13) {
      this.props.onFilterApply()
    }
  };
  render() {
    const {
      onFilterApply,
      onExportCsv,
      onDDChange,
      onFilterReset,
      selectedFormValues,
      onFormFieldChange,
      SelectedValues,
    } = this.props;
    const { student_name, email } =
    selectedFormValues;
      const {selected_status}=SelectedValues;
    
    return (
      <>
        <Row className="mt-2 mb-4">
          <Col>
            <Card className="card-user">
              <CardBody>
                <Row>
                  <Col>
                    <h5 className="form-heading">Filters</h5>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="form-row">
                      <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">
                        <label className="form-label text-muted">
                          {"Name"}:
                        </label>
                        <input
                          type="text"
                          name="student_name"
                          className={`input-text`}
                          value={student_name}
                          placeholder={"Search  username..."}
                          onChange={onFormFieldChange}
                          onKeyDown={(e) => this.onEnterPress(e)}
                          maxLength={"30"}
                        />
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">
                        <label className="form-label text-muted">
                          {"Email"}:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="email"
                          className={`input-text `}
                          value={email}
                          placeholder={"search email"}
                          onChange={onFormFieldChange}
                          onKeyDown={(e) => this.onEnterPress(e)}
                          maxLength={"30"}
                        />
                         
                      </div>
                      <div className="col-lg-0 col-md-0 col-sm-0 col-xs-0 mt-3">
                        <label className="mt-4 text-muted">
                          {"-"}
                        </label>
                      </div>

                    
                      <div className=" mb-3 col-lg-3  col-md-4 col-sm-12 col-xs-12">
                        <label className="form-label text-muted">
                          {"Status"}:
                        </label>
                        <Select
                          isClearable
                          isSearchable={false}
                          name="status"
                          value={selected_status}
                          onChange={(selectedOption, name) =>
                            onDDChange(selectedOption, name)
                          }
                          options={this.state.status}
                          classNamePrefix="react-select"
                        />
                      </div>

                      <div className=" float-right col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="float-left full-width-column">
                          <Button
                            onClick={onExportCsv}
                            color="primary"
                            className="caret button-full-width"
                          >
                            Export <MdArrowDropDown size={20} className="mb-1"/>
                          </Button>
                        </div>
                        <div className="float-right full-width-column">
                          <Button className="button-full-width" color="primary" onClick={onFilterApply}>
                            Apply Filter
                          </Button>
                        </div>
                        <div className="float-right full-width-column">
                          <Button
                            className="mr-3 button-full-width"
                            outline
                            color="primary mr-3"
                            onClick={onFilterReset}
                          >
                            Clear Filters
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}
